module.exports = __webpack_public_path__ + "img/icon-activity-detail-title.svg";